import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FaSun, FaMoon } from 'react-icons/fa'
import { useTheme } from '../utils/hooks'

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const { isDark, dispatch } = useTheme()

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navStyle = {
    background: isDark
      ? (scrolled ? 'rgba(15, 23, 42, 0.98)' : 'rgba(15, 23, 42, 0.95)')
      : (scrolled ? 'rgba(255, 255, 255, 0.98)' : 'rgba(255, 255, 255, 0.95)'),
    backdropFilter: scrolled ? 'blur(20px)' : 'blur(10px)'
  }

  return (
    <nav className="navbar" style={navStyle}>
      <div className="nav-container">
        <div className="nav-logo">
          <h2>Sander Buruma</h2>
        </div>
        <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          {[
            { label: 'Blog', path: '/blog', isRoute: true },
            { label: 'About', id: 'about' },
            { label: 'Projects', id: 'projects' },
            { label: 'Experience', id: 'experience' },
            { label: 'Contact', id: 'contact' },
            { label: 'CV', href: 'https://ftp.sanderburuma.nl/Sander%20Buruma%20CV%20-%202025-12%20-%20NL.pdf' }
          ].map(item => (
            <li key={item.id || item.href || item.path} className="nav-item">
              {item.isRoute ? (
                <Link
                  to={item.path}
                  className="nav-link"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  href={item.href || `#${item.id}`}
                  className="nav-link"
                  download={!!item.href}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              )}
            </li>
          ))}
        </ul>
        <button
          className={`nav-toggle ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
        <button
          className="theme-toggle"
          onClick={() => dispatch({ type: 'TOGGLE_THEME' })}
          aria-label="Toggle theme"
        >
          {isDark ? <FaSun /> : <FaMoon />}
        </button>
      </div>
    </nav>
  )
}

export default Navbar
